import { clients } from "../../../lib/axios";
import { AxiosError, AxiosResponse } from "axios";
import { UseMutationOptions, useMutation, useQuery, useQueryClient } from "react-query";
import { ProjectDto } from "../../projects";
import { UserKeys } from "./user.keys";
import { UserDto } from "../types";

const getOtherStat = async (id: string) => {
  const axios = await clients();

  return axios
    .get(`/api/projects/${id}`)
    .then((response: AxiosResponse<ProjectDto>) => response.data);
};

export const useGetOtherStat = (id: string | null | undefined) => {
  return useQuery(UserKeys.detail(id!), () => getOtherStat(id!), {
    enabled: id !== null && id !== undefined,
  });
};


const updateUserProfile = async (data: any) => {
  const axios = await clients();

  return axios
    .put("/api/Utils/UpdateUser", data /*, { 
      headers: {
        'content-type': 'multipart/form-data'
      } 
    }*/).then((response) => response.data as UserDto);
};

export function useUpdateUserProfile(
  options?: UseMutationOptions<UserDto, AxiosError, any>
) {
  const queryClient = useQueryClient();

  return useMutation(
    (newUser: any) => updateUserProfile(newUser),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(UserKeys.lists());
      },
      ...options,
    }
  );
}